import { axios } from '@/utils/request'

export function countDevice () {
  return axios({
    url: '/device/count',
    method: 'get'
  })
}

export function getDevice (id) {
  return axios({
    url: '/device/' + id,
    method: 'get'
  })
}

export function getGrowthBarChart () {
  return axios({
    url: '/device-growth-bar',
    method: 'get'
  })
}

export function getTop10CorpsCount () {
  return axios({
    url: '/device-top10-corps',
    method: 'get'
  })
}

export function getPollingInterval () {
  return axios({
    url: '/device/polling-interval',
    method: 'get'
  })
}

export function pageDeviceByClient (query) {
  return axios({
    url: '/devices',
    method: 'get',
    params: query
  })
}

export function pageDevice (query) {
  return axios({
    url: '/devices',
    method: 'post',
    data: query
  })
}

export function registerDevice (form) {
  return axios({
    url: '/device',
    method: 'post',
    data: form
  })
}

export function updateDeviceName (id, deviceName) {
  return axios({
    url: '/device/' + id,
    method: 'patch',
    params: { deviceName: deviceName }
  })
}
